module.exports = __webpack_public_path__ + "img/verification-proccess.b5a6b209.svg";